import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { ContractService } from "../../../../../auth/service/contract.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../../auth/service";
import { CoreConfigService } from "../../../../../../@core/services/config.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-gestione-costi-contratti",
  templateUrl: "./gestione-costi-contratti.component.html",
  styleUrls: ["./gestione-costi-contratti.component.scss"],
})
export class GestioneCostiContrattiComponent implements OnInit {
  public contentHeader: IContentHeader;

  public xlsx_file_content: any;

  public fileName: string = null;
  public lastUpdate: any = null;
  constructor(
    public _contractService: ContractService,
    private _router: Router,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
  ) {
    if (!!this._utilService.themeConfiguration.last_employee_contracts_update) {
      this.lastUpdate = this._utilService.formatDate(this._utilService.themeConfiguration.last_employee_contracts_update, "DD/MM/YYYY HH:mm");
    }
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: "TITLES.UPDATE_CONTRACTS_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.LIST_CONTRACTS_COSTS",
            isLink: true,
            link: "/dashboard/gestione/costi-contratti/list",
          },
          {
            name: "TITLES.UPDATE_CONTRACTS_COSTS",
            isLink: false,
          },
        ],
      },
    };
  }

  async handlerChangeFileInput($event: any) {
    this.fileName = $event.target.files[0].name;
    if ($event.target.files && $event.target.files[0]) {
      this._utilService.parseXLSX(
        $event.target.files[0],
        this._contractService.contract_costs_keys,
        { raw: true, defval: 0, header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"] },
        (data: any) => {
          this.xlsx_file_content = data.slice(1).map((item: any) => {
            item.is_apprendistato = item.is_apprendistato === "no" ? 0 : 1;
            Object.keys(item)
              .slice(8)
              .map((key: string) => {
                item[key] = item[key].toString().replace(" €", "");

                if (item[key].includes(",") && item[key].includes(".")) {
                  item[key] = item[key].toString().replace(".", "").replace(",", "");
                  item[key] = item[key].substring(0, item[key].length - 2) + "." + item[key].substring(item[key].length - 2);
                }

                let explode: any = String(item[key]).split(".");
                explode[1] = explode[1] ? String(explode[1]).padEnd(2, "0") : "00";
                item[key] = explode.join(".");
              });
            return item;
          });
        },
      );
    }
  }

  async save() {
    if (!this._authenticationService.hasCapability("manage_contracts_costs")) {
      window.history.back();
      return false;
    }
    await this._contractService
      .updateCosts({ costs: this.xlsx_file_content })
      .then(async (response: any) => {
        if (response.message === "Costs added") {
          await this._utilService.showSWALSuccess({ text: "CONTRACT_COSTS_UPDATED" });
          await this._router.navigateByUrl("/dashboard/gestione/costi-contratti/list");
          return;
        }
        return this._utilService.showSWALError({ text: "CONTRACT_COSTS_NOT_UPDATED" });
      })
      .catch(() => this._utilService.showSWALSuccess({ text: "CONTRACT_COSTS_NOT_UPDATED" }));
  }

  async downloadTemplate() {
    return this._utilService.document_file("static-template/template-calcolo-del-costo.xlsx");
  }
}
